import Empty from 'constants/empty';
import { createSelector } from 'reselect';
import { testTargetOffersSelector } from 'selectors/testTarget/offers/testTargetOffersSelector';

/**
 * Returns the raw `homepageCarouselRatings` Adobe Target offer, or an empty object when absent.
 */
const homepageCarouselRatingsSelector = createSelector(testTargetOffersSelector, offers => offers.homepageCarouselRatings || Empty.Object);

export { homepageCarouselRatingsSelector };
